import { defineBoot } from '#q-app'
import axios from 'axios'
import { Notify } from 'quasar'
import { useUserStore } from 'stores/user'
import { i18n } from 'boot/i18n'

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const api = axios.create({ baseURL: import.meta.env.VITE_API_ENDPOINT })
export default defineBoot(({ router }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api
  // app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  // app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API

  /**
   * Logs the user out after a 401 response and tells them why. The notification
   * is shown only while a token is still present, so parallel requests failing
   * with 401 at the same time produce a single notification.
   * @returns {Promise<void>}
   */
  async function handleUnauthenticated () {
    const user = useUserStore()
    if (user.hasToken) {
      Notify.create({ type: 'negative', message: i18n.global.t('auth.unauthenticated') })
    }
    await user.logout()
  }

  // automatically log out
  api.interceptors.response.use(
    async (response) => {
      if (response.status === 401) {
        await handleUnauthenticated()
      }
      return response
    },
    async (error) => {
      if (error.response && error.response.status === 401) {
        await handleUnauthenticated()
      }
      return Promise.reject(error)
    })

  // automatically add auth header
  api.interceptors.request.use(
    (config) => {
      const user = useUserStore()
      config.headers = { ...config.headers, ...user.getAuthHeader() }
      const modul = user.currentModul || router?.currentRoute?.value?.meta?.modul
      const url = String(config.url || '')
      const isSessionsRequest = url.includes('/sessions') || url.includes('sessions.json')
      const isLetterPreviewRequest = url.includes('letter-previews/')
      if (modul && !isSessionsRequest && !isLetterPreviewRequest && (config.params?.modul === undefined)) {
        config.params = { ...(config.params || {}), modul }
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    })
})

export { api }
